/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import btoa from 'btoa';
import {
  Container, Segment, Header, Card, Table, Button, List, Message,
  Popup, Input, Grid, Label,
} from 'semantic-ui-react';

import { REGEX_PATTERNS, base, firebaseAuth, cloudFunctionsURL } from '../../../config/constants';
import { AlertBox, ConfirmBox, SelectBox, setAlertMsg, pickOne, askConfirmation } from '../../../components/Modals';

export default class AddRecipient extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    match: PropTypes.object,
  }

  static defaultProps = {
    habilitations: { uid: null },
    match: { params: {} },
    history: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      draftedRecipient: {
        email: null,
        habilitations: {},
      },
      draftedRecipientId: null,
      savingRecipient: false,
      savingPreregistration: false,
      searchingUser: false,
      adding: {
        themes: false,
        citizenly: false,
        elected: false,
      },
    };
    this.fields = {
      email: null,
    };
  }

  componentDidMount() {
    this._ismounted = true;
    // console.log('did mount ', this.props);
    // base.bindToState('administrateurs', {
    //   context: this,
    //   state: 'admins',
    //   asArray: true,
    //   queries: {
    //     orderByChild: 'email',
    //     // limitToLast: 3
    //   },
    //   then: () => this.setState({ adminsLoading: false }),
    // });
    // if (this.props.match.params.id) {
    //   this.selectedBinding = base.bindToState(`administrateurs/${this.props.match.params.id}`, {
    //     context: this,
    //     state: 'selectedRecipient',
    //     then: () => this.setState({ selectedRecipientLoading: false, selectedRecipientId: this.props.match.params.id }),
    //   });
    // }
  }

  componentWillUnmount() {
    this._ismounted = false;
    clearTimeout(this.timeOutForSearchChange);
  }

  getFormattedList = (themeType) => {
    let wordNone;
    switch (themeType) {
      case 'themes':
        wordNone = 'Aucune profession';
        break;
      case 'citizenly':
        wordNone = 'Aucune commune';
        break;
      case 'elected':
        wordNone = 'Aucune circonscription';
        break;
      default:
        wordNone = '-';
        break;
    }

    if (
      !themeType
      || !this.state.draftedRecipient
      || !this.state.draftedRecipient) {
      return '';
    }

    if (this.state.draftedRecipient.fullAccess && this.state.draftedRecipient.fullAccess[themeType]
      && !this.props.habilitations.superuser && !this.state.draftedRecipient[themeType]) {
      return 'Accès total activé';
    }

    if (this.props.habilitations.superuser && !this.state.draftedRecipient[themeType]) {
      return null;
    }

    if (
      !themeType
      || !this.state.draftedRecipient[themeType]
      || Object.keys(this.state.draftedRecipient[themeType]).length === 0
    ) {
      return wordNone;
    }
    // console.log(this.state.draftedRecipient[themeType]);

    const themes = Object.keys(this.state.draftedRecipient[themeType]);
    return (
      <List>
        {
          _.map(themes, item => (
            <List.Item key={item}>
              <List.Content>
                <Button
                  fluid
                  animated="fade"
                  color="blue"
                  compact
                  size="tiny"
                  disabled={this.state.savingRecipient || this.state.savingPreregistration}
                  onClick={() => this.handleDeleteThemeAccess(themeType, item)}
                >
                  <Button.Content visible>
                    {item.toUpperCase()}
                  </Button.Content>
                  <Button.Content hidden>
                    Supprimer
                  </Button.Content>
                </Button>
              </List.Content>
            </List.Item>
          ))
        }
      </List>
    );
  };

  resetComponent = (spreadMe = {}) => this.setState({
    ...spreadMe,
    draftedRecipient: {
      email: null,
      fullAccess: {},
    },
    draftedRecipientId: null,
    savingRecipient: false,
    savingPreregistration: false,
    searchingUser: false,
    adding: {
      themes: false,
      citizenly: false,
      elected: false,
    },
  })

  handleAddThemeAccess = (themeType) => {
    this.setState({ adding: { ...this.state.adding, [themeType]: true } });

    let word;
    switch (themeType) {
      case 'themes':
        word = 'une profession';
        break;
      case 'citizenly':
        word = 'une commune';
        break;
      case 'elected':
        word = 'une circonscription';
        break;
      default:
        word = '';
        break;
    }

    return base.fetch(`${themeType}`, {
      context: this,
      asArray: true,
    }).then((data) => {
      const options = _.map(data, source => ({
        key: source.key,
        value: source.key,
        text: `${source.nom} (${source.key})`,
      }));
      this.setState({
        ...pickOne(
          `Ajouter ${word}`,
          `Vous souhaitez ajouter un accès à ${word}.<br/>
           Pour cela, veuillez choisir ${word} dans la liste ci-dessous puis cliquer sur "Ajouter" :`,
          'create',
          (themeId) => {
            this.setState({
              draftedRecipient: {
                ...this.state.draftedRecipient,
                [themeType]: {
                  ...this.state.draftedRecipient[themeType],
                  [themeId]: true,
                },
              },
            });
          },
          options,
          'Ajouter',
          `Sélectionnez ${word}`,
        ),
        adding: { ...this.state.adding, [themeType]: false },
      });
    }).catch((error) => {
      this.setState({
        ...setAlertMsg(error.code || null, 'Impossible de récupérer la liste', error.toString(), 'error'),
        adding: { ...this.state.adding, [themeType]: false },
      });
    });
  }

  handleDeleteThemeAccess = (themeType, themeId) => {
    this.setState({
      draftedRecipient: {
        ...this.state.draftedRecipient,
        habilitations: {
          ...this.state.draftedRecipient,
          [themeType]: _.omit(this.state.draftedRecipient[themeType], themeId),
        },
      },
    });
  }

  handleFetchUser = (email) => {
    if (!REGEX_PATTERNS.email.test(email)) {
      return this.setState(setAlertMsg(
        null,
        'Adresse email invalide',
        'Veuillez saisir une adresse email valide avant de rechercher l\'utilisateur associé.',
        'error',
      ));
    }
    this.setState({ searchingUser: true });
    firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/uidFromEmail/?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }).then(resp => resp.json()).then((data) => {
        if (data.found && data.user && data.user.uid) {
          return base.fetch(`users/${data.user.uid}`, {
            context: this,
          }).then((found) => {
            if (Object.keys(found).length !== 0) {
              return this.setState({
                ...askConfirmation(
                  'Impossible d\'ajouter ce destinataire',
                  'Cet utilisateur est <strong>déjà destinataire</strong>.<br/><br/>' +
                  'Pour modifier ses abonnements, cliquez sur<br/>"<em>Éditer ce' +
                  ' destinataire</em>"',
                  'warn',
                  () => this.props.history.push(`/recipients/edit/${data.user.uid}`),
                  'Editer ce destinataire',
                ),
                searchingUser: false,
              });
            }
            return this.setState({
              searchingUser: false,
              draftedRecipient: {
                ...this.state.draftedRecipient,
                email,
              },
              draftedRecipientId: data.found && data.user ? data.user.uid : null,
            });
          }).catch(error => this.setState({
            ...setAlertMsg(error.code || null, 'Erreur lors de la recherche', error.toString(), 'error'),
            searchingUser: false,
          }));
        }
        return this.setState({
          searchingUser: false,
          draftedRecipient: {
            ...this.state.draftedRecipient,
            email,
          },
          draftedRecipientId: data.found && data.user ? data.user.uid : null,
        });
      }))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de la recherche', error.toString(), 'error'),
        searchingUser: false,
      }));
    return true;
  }

  handleSubmit = () => {
    // console.log(this.state.draftedRecipientId, this.state.draftedRecipient);
    this.setState({
      savingRecipient: this.state.draftedRecipientId !== null,
      savingPreregistration: this.state.draftedRecipientId === null,
    });
    if (this.state.draftedRecipientId !== null) {
      base.post(
        `users/${this.state.draftedRecipientId}`,
        { data: this.state.draftedRecipient },
      ).then(() => {
        this.resetComponent(setAlertMsg(
          null,
          'Destinataire ajouté',
          'Cet destinataire a bien été ajouté',
          'success',
        ));
      });
    } else {
      base.post(
        `preinscriptions/${btoa(this.state.draftedRecipient.email)}`,
        {
          data: {
            ...this.state.draftedRecipient,
            themes: (this.state.draftedRecipient.themes
            && Object.keys(this.state.draftedRecipient.themes).length === 1
              ? Object.keys(this.state.draftedRecipient.themes)[0] : null),
            citizenly: (this.state.draftedRecipient.citizenly
            && Object.keys(this.state.draftedRecipient.citizenly).length === 1
              ? Object.keys(this.state.draftedRecipient.citizenly)[0] : null),
            elected: (this.state.draftedRecipient.elected
            && Object.keys(this.state.draftedRecipient.elected).length === 1
              ? Object.keys(this.state.draftedRecipient.elected)[0] : null),
          },
        },
      ).then(() => {
        this.resetComponent(setAlertMsg(
          null,
          'Destinataire préinscrit',
          'Cet destinataire a bien été préinscrit',
          'success',
        ));
      });
    }
  }

  handleToggleSuperuser = (trueIfActivateRequest, themeType) => this.setState({
    draftedRecipient: {
      ...this.state.draftedRecipient,
      fullAccess: {
        ...this.state.draftedRecipient.fullAccess,
        [themeType]: trueIfActivateRequest || null,
      },
    },
  })

  render() {
    // console.log(this.props.habilitations);
    // console.log(this.state.selectedRecipient);
    const noneSelected = this.state.draftedRecipient.email === null;
    const habObject = this.state.draftedRecipient;
    const recipient = this.state.draftedRecipient;

    return (
      <Container>
        <Segment basic>
          <Container text>
            <Segment textAlign="center" disabled={!noneSelected}>
              <Header textAlign="center" size="small">
                Recherchez un utilisateur par son adresse email (adresse exacte et entière)
              </Header>
              <Input
                autoFocus
                action={
                  {
                    color: 'teal',
                    labelPosition: 'right',
                    icon: 'search',
                    content: 'Rechercher cet utilisateur',
                    loading: this.state.searchingUser,
                    disabled: !noneSelected,
                    onClick: () => {
                      this.handleFetchUser(this.fields.email);
                    },
                  }
                }
                fluid
                type="email"
                disabled={this.state.searchingUser || !noneSelected}
                placeholder="Saisir une adresse email"
                onChange={(e, { value }) => {
                  this.fields.email = value.toLowerCase();
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.handleFetchUser(this.fields.email);
                  }
                }}

              />
              {noneSelected ? (
                <Message compact size="tiny">
                  <Message.Header size="mini">Ensuite, deux possibilités...</Message.Header>
                  <Message.List>
                    <Message.Item>
                      <strong>Soit l'utilisateur est déjà inscrit à ViGie</strong> et vous pourrez modifier ses
                      abonnements et il sera immédiatement ajouté aux destinataires des thèmes choisis.
                    </Message.Item>
                    <Message.Item>
                      <strong>Soit l'utilisateur n'est pas encore inscrit à ViGie</strong>, vous pourrez alors
                      pré-configurer les thèmes auxquels sera abonné l'utilisateur lorsqu'il s'inscrira en utilisant
                      cette adresse comme identifiant.
                    </Message.Item>
                  </Message.List>
                </Message>
              ) : (
                <Message compact>
                  Pour choisir un autre utilisateur, vous devez annuler votre saisie à l'aide du bouton en bas de page.
                </Message>
              )}
            </Segment>
          </Container>
          <Segment basic disabled={noneSelected}>
            <Card fluid raised={!noneSelected}>
              <Card.Content>
                <Card.Header
                  size="small"
                  content={
                    !noneSelected ?
                      recipient.email : '-'
                  }
                />
                <Card.Meta
                  content={
                    !noneSelected ?
                      recipient.email : 'Aucun utilisateur sélectionné'
                  }
                />
              </Card.Content>
              <Card.Content>
                <Label as="span" color={this.state.draftedRecipientId ? 'green' : 'black'} ribbon>
                  {
                    this.state.draftedRecipientId
                      ? 'Utilisateur existant' : 'Préinscription'
                  }
                </Label>
                <Card.Meta
                  content={this.state.draftedRecipientId ? 'Abonnements du nouveau destinataire'
                    : 'Abonnements du destinataire préinscrit'}
                />
                <Table definition={!noneSelected} color={!noneSelected ? 'blue' : null}>
                  <Table.Body>
                    {this.props.habilitations.superuser || this.props.habilitations.themes ? (
                      <Table.Row disabled={noneSelected}>
                        <Table.Cell>Professionnels</Table.Cell>
                        <Table.Cell textAlign="center">
                          {this.getFormattedList('themes')}
                          {this.props.habilitations.superuser ? (
                            <Button
                              fluid
                              animated="fade"
                              color={
                                noneSelected || !(habObject.fullAccess && habObject.fullAccess.themes)
                                  ? null : 'red'
                              }
                              onClick={
                                (e) => {
                                  e.target.blur();
                                  return noneSelected
                                    || this.handleToggleSuperuser(
                                      !(habObject.fullAccess && habObject.fullAccess.themes),
                                      'themes',
                                    );
                                }
                              }
                            >
                              <Button.Content visible>
                                {noneSelected
                                || !(habObject.fullAccess && habObject.fullAccess.themes)
                                  ? 'Accès total désactivé' : 'Accès total activé'}
                              </Button.Content>
                              <Button.Content hidden>
                                {noneSelected || !(habObject.fullAccess && habObject.fullAccess.themes)
                                  ? 'Activer' : 'Désactiver'}
                              </Button.Content>
                            </Button>) : null
                          }
                        </Table.Cell>
                        <Table.Cell collapsing>
                          {!habObject.themes ? (
                            <Popup
                              trigger={
                                <Button
                                  icon="add"
                                  color="green"
                                  inverted
                                  circular
                                  disabled={noneSelected
                                  || this.state.savingRecipient || this.state.savingPreregistration}
                                  loading={this.state.adding.themes}
                                  onClick={() => this.handleAddThemeAccess('themes')}
                                />
                              }
                            >
                              <Popup.Content>Ajouter une profession</Popup.Content>
                            </Popup>
                          ) : null}
                        </Table.Cell>
                      </Table.Row>
                    ) : null}
                    {this.props.habilitations.superuser || this.props.habilitations.citizenly ? (
                      <Table.Row disabled={noneSelected}>
                        <Table.Cell>Participation Citoyenne</Table.Cell>
                        <Table.Cell textAlign="center">
                          {this.getFormattedList('citizenly')}
                          {this.props.habilitations.superuser ? (
                            <Button
                              fluid
                              animated="fade"
                              color={
                                noneSelected || !(habObject.fullAccess && habObject.fullAccess.citizenly)
                                  ? null : 'red'
                              }
                              onClick={
                                (e) => {
                                  e.target.blur();
                                  return noneSelected
                                    || this.handleToggleSuperuser(
                                      !(habObject.fullAccess && habObject.fullAccess.citizenly),
                                      'citizenly',
                                    );
                                }
                              }
                            >
                              <Button.Content visible>
                                {noneSelected
                                || !(habObject.fullAccess && habObject.fullAccess.citizenly)
                                  ? 'Accès total désactivé' : 'Accès total activé'}
                              </Button.Content>
                              <Button.Content hidden>
                                {noneSelected || !(habObject.fullAccess && habObject.fullAccess.citizenly)
                                  ? 'Activer' : 'Désactiver'}
                              </Button.Content>
                            </Button>) : null
                          }
                        </Table.Cell>
                        <Table.Cell collapsing>
                          {!(habObject.citizenly)
                          && (this.props.habilitations.superuser || this.props.habilitations.citizenly) ? (
                            <Popup
                              trigger={
                                <Button
                                  icon="add"
                                  color="green"
                                  inverted
                                  circular
                                  disabled={noneSelected
                                  || this.state.savingRecipient || this.state.savingPreregistration}
                                  loading={this.state.adding.citizenly}
                                  onClick={() => this.handleAddThemeAccess('citizenly')}
                                />
                              }
                            >
                              <Popup.Content>Ajouter une commune</Popup.Content>
                            </Popup>
                          ) : null}
                        </Table.Cell>
                      </Table.Row>
                    ) : null}
                    {this.props.habilitations.superuser || this.props.habilitations.elected ? (
                      <Table.Row disabled={noneSelected}>
                        <Table.Cell>Contact Élus</Table.Cell>
                        <Table.Cell textAlign="center">
                          {this.getFormattedList('elected')}
                          {this.props.habilitations.superuser ? (
                            <Button
                              fluid
                              animated="fade"
                              color={
                                noneSelected || !(habObject.fullAccess && habObject.fullAccess.elected)
                                  ? null : 'red'
                              }
                              onClick={
                                (e) => {
                                  e.target.blur();
                                  return noneSelected
                                    || this.handleToggleSuperuser(
                                      !(habObject.fullAccess && habObject.fullAccess.elected),
                                      'elected',
                                    );
                                }
                              }
                            >
                              <Button.Content visible>
                                {noneSelected
                                || !(habObject.fullAccess && habObject.fullAccess.elected)
                                  ? 'Accès total désactivé' : 'Accès total activé'}
                              </Button.Content>
                              <Button.Content hidden>
                                {noneSelected || !(habObject.fullAccess && habObject.fullAccess.elected)
                                  ? 'Activer' : 'Désactiver'}
                              </Button.Content>
                            </Button>) : null
                          }
                        </Table.Cell>
                        <Table.Cell collapsing>
                          {!(habObject.elected && !this.props.habilitations.superuser)
                          && (this.props.habilitations.superuser || this.props.habilitations.elected) ? (
                            <Popup
                              trigger={
                                <Button
                                  icon="add"
                                  color="green"
                                  inverted
                                  circular
                                  disabled={noneSelected
                                  || this.state.savingRecipient || this.state.savingPreregistration}
                                  loading={this.state.adding.elected}
                                  onClick={() => this.handleAddThemeAccess('elected')}
                                />
                              }
                            >
                              <Popup.Content>Ajouter une circonscription</Popup.Content>
                            </Popup>
                          ) : null}
                        </Table.Cell>
                      </Table.Row>
                    ) : null}
                  </Table.Body>
                </Table>
              </Card.Content>
              <Card.Content>
                <Segment basic textAlign="center">
                  <Grid columns={2}>
                    <Grid.Row>
                      <Grid.Column>
                        <Button
                          content="Annuler la saisie"
                          fluid
                          icon="cancel"
                          labelPosition="left"
                          color="grey"
                          onClick={() => this.resetComponent()}
                          disabled={noneSelected || this.state.savingRecipient || this.state.savingPreregistration}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          content={
                            this.state.draftedRecipientId
                              ? 'Valider l\'ajout de ce destinataire' : 'Préinscrire ce destinataire'
                          }
                          icon="add"
                          fluid
                          positive
                          labelPosition="right"
                          onClick={() => this.handleSubmit()}
                          loading={this.state.savingRecipient || this.state.savingPreregistration}
                          disabled={noneSelected}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Card.Content>
            </Card>
          </Segment>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
        <SelectBox
          propagateClosure={() => this.setState({ pick: { open: false } })}
          {...this.state.pick}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/Recipients/AddRecipient.js